























import { Prop, Component, Vue } from 'vue-property-decorator'
import { UserTarget } from '@/api/model/user-target'
import { UserTargetAPI } from '@/api/backend-client'
import { User } from '@/api/model/user'
import { Pipeline } from '@/api/model/pipeline'
import { v4 as uuid } from 'uuid'
import { escapeHtml } from '@/helpers/html'

export interface CreateTargetFormModel {
    fromDate: Date,
    untilDate: Date,
    referralPipeline: Pipeline|null,
    referralType: string,
    orderType: string,
    direction: string,
    quantity: number,
    turnover: number,
}

@Component
export default class TargetsCreate extends Vue {
    @Prop({ required: true }) readonly user: User|null
    submitting: boolean = false
    createTargetForm: CreateTargetFormModel = {
        fromDate: null,
        untilDate: null,
        referralPipeline: null,
        referralType: null,
        orderType: null,
        direction: 'out',
        quantity: null,
        turnover: null,
    }

    resetForm(): void {
        this.createTargetForm = {
            fromDate: null,
            untilDate: null,
            referralPipeline: null,
            referralType: null,
            orderType: null,
            direction: 'out',
            quantity: null,
            turnover: null,
        }
    }

    async createTarget(): Promise<void> {
        try {
            this.submitting = true
            const target = UserTarget.fromData({
                user: this.user.resourceIdentifier,
                id: uuid(),
                fromDate: this.createTargetForm.fromDate,
                untilDate: this.createTargetForm.untilDate,
                referralPipeline: this.createTargetForm.referralPipeline,
                referralType: this.createTargetForm.referralType,
                orderType: this.createTargetForm.orderType,
                direction: this.createTargetForm.direction,
                quantity: this.createTargetForm.quantity,
                turnover: this.createTargetForm.turnover,
            })

            await UserTargetAPI.create(target)
            this.onCreated(target)

        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })

        } finally {
            this.submitting = false
        }
    }

    onCreated(target: UserTarget): void {
        this.$emit('created', target)
    }

    onCancel(): void {
        this.$emit('cancel')
    }
}
